class Template {
    constructor() {
        this.baseUrl = $('meta[name="baseUrl"]').attr('content');
        this.baseUrlSocket = $('meta[name="baseUrlSocket"]').attr('content');
        this.csrfToken = $('meta[name="csrf-token"]').attr('content');
        this.csrfTokenName = $('meta[name="csrf-token"]').attr('data-name');
        this.sessionData = JSON.parse($('#session-data').text());
        this.user_id = this?.sessionData?.user_id;

        // สร้าง prototype สำหรับ Module เพื่อให้เข้าถึง Template ได้
        this.initModules();

        // หนึ่งหน้าสร้าง subclass ของ Template หลายตัว (Ticket สร้าง TicketKanban/
        // TicketComment/TicketRelated/TicketMergeRequest/DeletedTickets ต่ออีกชั้น)
        // presence กับ push เป็นงานระดับหน้า ไม่ใช่ระดับ instance จึงให้รันครั้งเดียว
        if (!Template._pageBootstrapped) {
            Template._pageBootstrapped = true;
            this.initPresence();
            this.initPushNotification();
        }
    }

    initPushNotification() {
        const self = this;
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

        // งาน push ไม่ใช่สิ่งที่ผู้ใช้รออยู่หน้าจอ — เลื่อนไปหลังหน้าโหลดเสร็จ
        // เพื่อไม่ให้แย่งคิวกับ request ที่โหลดข้อมูลของหน้า
        this._whenIdle(() => self._subscribePush());
    }

    _whenIdle(fn) {
        const run = () =>
            typeof requestIdleCallback === 'function'
                ? requestIdleCallback(fn, { timeout: 5000 })
                : setTimeout(fn, 2000);

        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, { once: true });
    }

    /**
     * ขอ VAPID key แล้ว subscribe push
     * key เป็นค่าคงที่จึง cache ไว้ ส่วนการ subscribe ที่ล้มเหลวจะเว้นระยะก่อนลองใหม่
     * ไม่ใช่ลองซ้ำทุกครั้งที่เปิดหน้า
     * @author เต้ย
     */
    async _subscribePush() {
        const VAPID_KEY_STORAGE = 'push:vapidPublicKey';
        const FAILED_AT_STORAGE = 'push:lastSubscribeFailedAt';
        const RETRY_COOLDOWN = 86400000;

        try {
            const registration = await navigator.serviceWorker.ready;
            if (await registration.pushManager.getSubscription()) return;

            const failedAt = parseInt(localStorage.getItem(FAILED_AT_STORAGE) || '0', 10);
            if (Date.now() - failedAt < RETRY_COOLDOWN) return;

            const permission = await Notification.requestPermission();
            if (permission !== 'granted') return;

            let vapidKey = localStorage.getItem(VAPID_KEY_STORAGE);
            if (!vapidKey) {
                const res = await axios.get('presence/vapid_key');
                vapidKey = res.data?.data?.publicKey || res.data?.publicKey;
                if (!vapidKey) return;
                localStorage.setItem(VAPID_KEY_STORAGE, vapidKey);
            }

            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: this._urlBase64ToUint8Array(vapidKey),
            });

            localStorage.removeItem(FAILED_AT_STORAGE);
            await axios.post('presence/push_subscribe', { subscription });
        } catch (err) {
            localStorage.setItem(FAILED_AT_STORAGE, String(Date.now()));
            localStorage.removeItem(VAPID_KEY_STORAGE);
            console.warn('[push] subscribe ไม่สำเร็จ', err?.name || err);
        }
    }

    _urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const raw = atob(base64);
        const arr = new Uint8Array(raw.length);
        for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
        return arr;
    }

    initPresence() {
        const HEARTBEAT_INTERVAL = 240000;
        const STORAGE_KEY = 'presence:lastHeartbeat';
        let isActive = false;

        ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'].forEach((evt) => {
            document.addEventListener(
                evt,
                () => {
                    isActive = true;
                },
                { passive: true },
            );
        });

        // กัน multi-tab ยิงซ้ำ — ใช้ timestamp ใน localStorage shared ทั้ง origin
        // แท็บใดส่งสำเร็จจะ stamp เวลา แท็บอื่นที่ครบรอบภายใน window เดียวกันจะข้าม
        const recentlySent = () => {
            const last = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
            return Date.now() - last < HEARTBEAT_INTERVAL * 0.9;
        };

        const sendHeartbeat = () => {
            if (isActive && !recentlySent()) {
                isActive = false;
                localStorage.setItem(STORAGE_KEY, String(Date.now()));
                axios.post('presence/heartbeat', {}).finally(() => {
                    setTimeout(sendHeartbeat, HEARTBEAT_INTERVAL);
                });
            } else {
                setTimeout(sendHeartbeat, HEARTBEAT_INTERVAL);
            }
        };

        if (!recentlySent()) {
            localStorage.setItem(STORAGE_KEY, String(Date.now()));
            axios.post('presence/heartbeat', {}).catch(() => {});
        }
        setTimeout(sendHeartbeat, HEARTBEAT_INTERVAL);

        this.refreshPresenceDots();
        this._watchPresenceTargets();
    }

    /**
     * เฝ้าดู element ที่ถูก render ทีหลัง (การ์ด kanban, แถวตาราง) แล้วเติม dot ให้
     * @author เต้ย
     */
    _watchPresenceTargets() {
        if (typeof MutationObserver !== 'function') return;

        let pending = null;
        const observer = new MutationObserver((records) => {
            const hasTarget = records.some((rec) =>
                [...rec.addedNodes].some(
                    (node) =>
                        node.nodeType === 1 &&
                        (node.matches?.('[data-user-id]') || node.querySelector?.('[data-user-id]')),
                ),
            );
            if (!hasTarget) return;

            clearTimeout(pending);
            pending = setTimeout(() => this.refreshPresenceDots(), 400);
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    refreshPresenceDots() {
        const elements = this._presenceTargets();
        if (elements.length === 0) return;

        // หน้าที่ preload presence มาแล้ว (เช่น ticket ที่ได้ online_users จาก dashboard_init)
        // ไม่ต้องยิงซ้ำ — endpoint นี้ใช้เวลาเกือบทั้งหมดไปกับ hop PHP → nodesupport
        // การ์ดที่ render ทีหลังใช้ชุดข้อมูลเดิมที่ preload ไว้
        if (Template.deferPresence) {
            if (Template._presenceCache) this.applyPresence(Template._presenceCache);
            return;
        }

        const userIds = [...new Set(elements.map((el) => el.dataset.userId))];
        if (userIds.length === 0) return;

        axios
            .get('presence/online_status', { params: { user_ids: userIds.join(',') } })
            .then((res) => {
                const data = res.data?.data?.data || res.data?.data || [];
                this.applyPresence(data);
            })
            .catch(() => {});
    }

    _presenceTargets() {
        return [...document.querySelectorAll('[data-user-id]')].filter((el) => !el.querySelector('.presence-dot'));
    }

    /**
     * วาด presence dot จากข้อมูลที่มีอยู่แล้ว
     * ถ้า users เป็น null (เช่น Redis ฝั่ง backend ไม่พร้อม) จะ fallback ไปยิง endpoint เดิม
     * @param {Array|null} users - [{ user_id, is_online }]
     * @author เต้ย
     */
    applyPresence(users) {
        if (!Array.isArray(users)) {
            // backend ไม่มีข้อมูลให้ (Redis ไม่พร้อม) — กลับไปใช้ทางเดิม
            Template.deferPresence = false;
            Template._presenceCache = null;
            this.refreshPresenceDots();
            return;
        }

        Template._presenceCache = users;

        const elements = this._presenceTargets();
        if (elements.length === 0) return;

        const statusMap = {};
        users.forEach((u) => {
            statusMap[String(u.user_id)] = u.is_online;
        });

        elements.forEach((el) => {
            const isOnline = statusMap[String(el.dataset.userId)] || false;
            let dot = el.querySelector('.presence-dot');
            if (!dot) {
                el.style.position = 'relative';
                dot = document.createElement('div');
                dot.className = 'presence-dot';
                el.appendChild(dot);
            }
            dot.classList.remove('online', 'offline');
            dot.classList.add(isOnline ? 'online' : 'offline');
        });
    }

    initModules() {
        /**
         * สร้าง module ต่างๆ โดยส่ง this (Template) ไป
         * @author เต้ย
         */

        /** Module Socket */
        this._moduleSocket = new ModuleSocket(this);

        /** Module Helper */
        this._moduleHelper = new ModuleHelper(this);

        /** Module Modal */
        this._moduleModal = new ModuleModal(this);

        /** Module Flatpickr */
        this._moduleFlatpickr = new ModuleFlatpickr(this);

        /** Module Toast */
        this._moduleToast = new ModuleToast(this);

        /** Module Table */
        this._moduleTable = new ModuleTable(this);

        /** Axios Client */
        this._axiosClient = new AxiosClient(this);

        /** Module Select */
        this._moduleSelect = new ModuleSelect();
    }

    /**
     * ตั้งค่า csrf token
     * @param {string} token - csrf token
     * @author เต้ย
     */
    setCsrfToken(token) {
        this.csrfToken = token;
    }
    /**
     * @author เต้ย
     * @description แสดงหน้าต่าง loading
     * @param {string} type - ประเภทของ loading
     * - show: แสดงหน้าต่าง loading
     * - hide: ซ่อนหน้าต่าง loading
     */
    pageLoader(type = 'show') {
        if (type == 'show') {
            // ใช้ Swal แทน KTApp
            Swal.fire({
                title: 'กรุณารอสักครู่...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        } else {
            Swal.close();
        }
    }
}
